import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-98800b8a"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = ["innerHTML"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'big_text_breaker',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function formattedTitle() {
            const title = props.d.title;
            // Remove '&nbsp;'
            title.replace('&nbsp;', '');
            if (props.d.title === 'Services') {
                // Wrap 'r' with <span> tags
                return title.replace('r', '<span class="tracking-widest">r</span>');
            }
            else if (title === 'Delivery') {
                // Wrap 'r' with <span> tags
                return title.replace('r', '<span class="tracking-widest" style="padding-right:8px">r</span>');
            }
            else if (title === 'Results') {
                // Wrap 't' with <span> tags
                return title.replace('t', '<span class="tracking-widest">t</span>');
            }
            return title;
        }
        // Function to remove HTML tags from the title
        function removeHtmlTags(title) {
            return title.replace(/<[^>]+>/g, '');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["big_text_breaker", [{ 'container': __props.d.desktop_container == 'true', 'big_text_breaker__flush': __props.d.isFlush }]]),
                id: props.d.title,
                style: _normalizeStyle({ 'background-color': __props.d.isFlush ? null : (__props.d.background_colour ? __props.d.background_colour : '#fff') })
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass({ 'big_text_breaker__sticky': __props.d.position == 'sticky' }),
                    style: _normalizeStyle({ 'background-color': __props.d.isFlush ? null : (__props.d.background_colour ? __props.d.background_colour : '#fff') })
                }, [
                    _createElementVNode("span", {
                        class: _normalizeClass(["big_text_breaker__big-text", [`big_text_breaker__big-text--${removeHtmlTags(props.d.title).length}`, { 'big_text_breaker__big-text--sticky': __props.d.position == 'sticky' }]]),
                        innerHTML: formattedTitle(),
                        style: _normalizeStyle(`background-color: (${__props.d.isFlush} ? null : ${__props.d.background_colour ? __props.d.background_colour : '#fff'})`)
                    }, null, 14, _hoisted_2)
                ], 6)
            ], 14, _hoisted_1));
        };
    }
});
